import React from 'react'
import BallySportsNBA from 'src/components/page/bally-sports-nba'
import { videos } from 'src/constants/videos'
import { teamIds } from 'src/constants/personalizationIds'

export default (props) => (
  <BallySportsNBA
    location={props.location}
    video={videos.bally_thunder.videoUrl}
    staticAnnotation={videos.bally_thunder.staticAnnotation}
    title="Watch Oklahoma City basketball live"
    subtitle="Stream the Thunder on FanDuel Sports Network Oklahoma"
    teamId={teamIds['Oklahoma City Thunder']}
  />
)
